import script from "./imageResizer.vue?vue&type=script&setup=true&lang=js"
export * from "./imageResizer.vue?vue&type=script&setup=true&lang=js"

import "./imageResizer.vue?vue&type=style&index=0&id=5578ce4b&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5578ce4b"]])

export default __exports__